<template>
  <path
    d="M22 12.0002C22 6.48024 17.52 2.00024 12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002ZM15 6.50024L18.15 9.65024C18.35 9.85024 18.35 10.1602 18.15 10.3602L15 13.5002V11.0002H11V9.00024H15V6.50024ZM9 17.5002L5.85 14.3502C5.65 14.1502 5.65 13.8402 5.85 13.6402L9 10.5002V13.0002H13V15.0002H9V17.5002Z"
  />
</template>
